import { EMPTY_LIST } from '../../constants/common'
import { FileListDownloadAll } from '../File'

import { useFilesGallery } from './FilesContentGallery.hooks'
import { FilesGallery } from './FilesGallery'
import { FilesList } from './FilesList'

import * as styles from './FilesContentGallery.module.css'

function FilesContentGallery({
  DownloadAll = FileListDownloadAll,
  files,
  filesListClassName,
  scope,
  uploadingFiles = EMPTY_LIST,
  uploadProps,
  onRemoveFile,
}) {
  const galleryProps = useFilesGallery({ files })

  return (
    <div className={styles.container}>
      {files.length > 0 ? (
        <FilesGallery {...galleryProps} files={files} scope={scope} />
      ) : null}
      {files.length > 1 || uploadProps ? (
        <FilesList
          {...galleryProps}
          className={filesListClassName}
          files={files}
          uploadingFiles={uploadingFiles}
          uploadProps={uploadProps}
          onRemoveFile={onRemoveFile}
        />
      ) : null}
      {DownloadAll && files.length > 0 ? <DownloadAll files={files} /> : null}
    </div>
  )
}

export default FilesContentGallery
